/**
 * @module header
 */
(function () {
    const uniNavBtn = document.querySelector(
        ".qld__main-nav__uninav-item-toggle",
    );
    const uniNavMenu = document.querySelector(".qld__main-nav__uninav-sub");

    // Bail out early if required elements do not exist
    if (!uniNavBtn || !uniNavMenu) {
        return;
    }
    let isOpen = false;

    uniNavBtn?.addEventListener("click", () => {
        isOpen = !isOpen; // Toggle the isOpen state

        uniNavBtn.classList.toggle("qld__main-nav__uninav--open");
        uniNavBtn.classList.toggle("qld__main-nav__uninav--closed");

        uniNavMenu.classList.toggle("qld__main-nav__uninav-accordion--closed");
        uniNavMenu.classList.toggle("qld__main-nav__uninav-accordion--open");
    });
})();
